import styled from "styled-components";

export const WorkOrders = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 640px) {
    font-size: 0.875rem;
  }
`;

export const Orden = styled.div`
  background-color: ${(props) => props.bg};
`;

export const OrdenInfo = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 50% 30%;
  grid-gap: 2.5%;

  @media (max-width: 640px) {
    font-size: 0.875rem;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    gap: 20px;
  }
`;

export const PersonInfo = styled.div`
  display: grid;
  grid-template-columns: 20% 75%;
  grid-gap: 5%;

  @media (max-width: 768px) {
    grid-template-columns: 35% 65%;
  }
`;

export const PersonInfoSub = styled.div`
  display: grid;
  grid-template-columns: 50% 10% auto;
  gap: 7px;

  @media (max-width: 768px) {
    grid-template-columns: 35% 10% auto;
    font-size: 0.875rem;
    gap: 10px;
  }
`;

export const CommentSection = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 5%;

  @media (max-width: 640px) {
    font-size: 0.875rem;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    gap: 16px;
    padding: 12px;
  }
`;

export const CommentStats = styled.div`
  display: grid;
  grid-template-columns: 35% 5% auto;
  grid-gap: 15px;
  align-self: center;

  @media (max-width: 768px) {
    grid-template-columns: 45% 8% auto;
  }
`;
